import { testimonials } from '@/mocks/categories';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/60 bg-accent-100/50 text-accent-900 text-xs font-medium mb-4">
            Testimonials
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            What Our Users Say
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl">
            Real buyers sharing their experiences with the <strong>AllChinaBuy Spreadsheet</strong>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t) => (
            <div
              key={t.handle}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatarUrl}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">@{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-0.5 mt-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}